import { render } from "./TopTenListComponent.vue?vue&type=template&id=0efd212a&scoped=true&ts=true"
import script from "./TopTenListComponent.vue?vue&type=script&lang=ts"
export * from "./TopTenListComponent.vue?vue&type=script&lang=ts"

import "./TopTenListComponent.vue?vue&type=style&index=0&id=0efd212a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0efd212a"]])

export default __exports__